import { Typography, TypographyProps } from "@mui/material"

const Text = ({ children, ...rest }: TypographyProps) => {
  return (
    <Typography
      fontSize={24}
      fontFamily="Roboto Slab, serif"
      fontWeight={400}
      {...rest}
    >
      {children}
    </Typography>
  )
}

export default Text
